import {styled} from "@reside/ui";

export const PDFContainer = styled.div`
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  font-family: initial;
  font-size: initial;
  line-height: initial;
  width: 90%;
  padding: 16px;
  position: relative;
  margin-bottom: 32px;
`;

export const PDFDocument = styled.div`
  flex: 1;
  overflow: auto;
  font-family: initial;
  font-size: initial;
  line-height: initial;
  min-height: 400px;
  padding-top: 16px;
  overflow-x: hidden;
`;

export const PDFViewerContainer = styled.div`
  height: 100vh;
`;
